export class DisplayData {
  widgetId: string;
  label: string;
  count: number;
  percentage: number;
}
